// Module
var code = "<div class=\"graphRegion\" ng-controller=\"longitudinalGraphController as ctrl\">\n    <div class=\"graphContainer full-size\">\n        <long-graph class=\"full-size\" long-report=\"ctrl.longData\"></long-graph>\n    </div>\n</div>\n";
// Exports
module.exports = code;